import { render, staticRenderFns } from "./task_disease.vue?vue&type=template&id=61b2bf94&scoped=true"
import script from "./task_disease.vue?vue&type=script&lang=js"
export * from "./task_disease.vue?vue&type=script&lang=js"
import style0 from "./task_disease.vue?vue&type=style&index=0&id=61b2bf94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b2bf94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b2bf94')) {
      api.createRecord('61b2bf94', component.options)
    } else {
      api.reload('61b2bf94', component.options)
    }
    module.hot.accept("./task_disease.vue?vue&type=template&id=61b2bf94&scoped=true", function () {
      api.rerender('61b2bf94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_disease.vue"
export default component.exports